import React from 'react';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './ResidentialSolar.css';

import AkPhoto from '../images/ak.png';
import Ak1Photo from '../images/ak1.png';
import Ak2Photo from '../images/ak2.png';
import Ak3Photo from '../images/ak3.png';
import KaralePhoto from '../images/karale.jpeg';
import BslPhoto from '../images/bsl.jpeg';

const projects = [
    { img: AkPhoto, title: "Residential solar, Akola", capacity: "4kw" },
    { img: Ak1Photo, title: "Residential Solar structure, Akola", capacity: "7kw" },
    { img: Ak2Photo, title: "Residential solar, Khamgaon", capacity: "7kw" },
    { img: Ak3Photo, title: "Residential solar", capacity: "5kw" },
    { img: KaralePhoto, title: "Residential solar, Shegaon", capacity: "3kw" },
    { img: AkPhoto, title: "Residential solar installation", capacity: "Structure material" },
    { img: BslPhoto, title: "Bhusawal", capacity: "3kw" }
];

const ResidentialSolar = () => {
    return (
        <section id="residential-solar" className="py-5">
            <div className="container">
                <h1 className="residential-solar-heading">
                    Residential Solar Projects
                </h1>

                <div className="row gy-5"> {/* gap between rows */}
                    {projects.map((project, index) => (
                        <div className="col-lg-6" key={index}>
                            <div className="residential-card">
                                <div
                                    className="residential-card-image"
                                    style={{ backgroundImage: `url(${project.img})` }}
                                ></div>
                                <div className="residential-card-text">
                                    <h3>{project.title}</h3>
                                    <p>Capacity {project.capacity}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ResidentialSolar;
